import React from 'react'
import Plot from 'react-plotly.js'

export default function BarChart({ data }) {
    const convertDescription = (string) => {
        if (typeof string === 'string') {
            let arr = string.split('_')
            return arr.join(' ')
        }
    }
    const xvalue = data
        ? Object.keys(data).map((key) => convertDescription(key))
        : []
    const yvalue = data
        ? Object.keys(data).map((key) => data[key]?.total_calculated_amount)
        : []

    const generateColors = (count) => {
        const colors = [
            '#4285F4',
            '#10B981',
            '#F59E0B',
            '#EF4444',
            '#8B5CF6',
            '#06B6D4',
            '#EC4899',
            '#F97316',
            '#14B8A6',
            '#A855F7',
            '#3B82F6',
            '#22C55E',
            '#EAB308',
            '#EF4444',
            '#8B5CF6',
        ]

        // If we need more colors than defined, generate additional ones
        if (count > colors.length) {
            for (let i = colors.length; i < count; i++) {
                const hue = (i * 137.5) % 360 // Golden angle for good color distribution
                colors.push(`hsl(${hue}, 70%, 55%)`)
            }
        }

        return colors.slice(0, count)
    }

    return (
        <div className="rounded-lg bg-white px-6 pt-6 pb-6 shadow-sm">
            <h4 className="font-bold text-black text-lg mb-4">
                Spend by Carrier
            </h4>
            <div>
                <Plot
                    data={[
                        {
                            x: [...xvalue],
                            y: [...yvalue],
                            type: 'bar',
                            marker: {
                                color: generateColors(xvalue.length),
                            },
                        },
                    ]}
                    layout={{
                        showlegend: false,
                        xaxis: {
                            showgrid: false,
                            showline: false,
                        },
                        yaxis: {
                            tickformat: ',.0f',
                            tickprefix: 'A$',
                            gridcolor: '#E5E7EB',
                            showline: false,
                            rangemode: 'tozero',
                        },
                        plot_bgcolor: 'white',
                        paper_bgcolor: 'white',
                        margin: {
                            l: 60,
                            r: 20,
                            t: 20,
                            b: 60,
                        },
                        bargap: 0.4,
                    }}
                    config={{
                        displayModeBar: false,
                        responsive: true,
                    }}
                    useResizeHandler={true}
                    style={{ width: '100%', height: '400px' }}
                />
            </div>
        </div>
    )
}
